"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PmWithdrawCalculationsStatus = void 0;
var PmWithdrawCalculationsStatus;
(function (PmWithdrawCalculationsStatus) {
    PmWithdrawCalculationsStatus["OK"] = "OK";
    PmWithdrawCalculationsStatus["AMOUNT_IS_NOT_VALID"] = "AMOUNT_IS_NOT_VALID";
    PmWithdrawCalculationsStatus["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    PmWithdrawCalculationsStatus["WALLET_NOT_FOUND"] = "WALLET_NOT_FOUND";
    PmWithdrawCalculationsStatus["NOT_ENOUGH_BALANCE"] = "NOT_ENOUGH_BALANCE";
    PmWithdrawCalculationsStatus["PLAYER_NOT_FOUND"] = "PLAYER_NOT_FOUND";
    PmWithdrawCalculationsStatus["PAYMENT_GATEWAY_INACTIVE"] = "PAYMENT_GATEWAY_INACTIVE";
    PmWithdrawCalculationsStatus["PLAYER_IS_BLOCKED"] = "PLAYER_IS_BLOCKED";
    PmWithdrawCalculationsStatus["OPERATOR_NOT_FOUND"] = "OPERATOR_NOT_FOUND";
    PmWithdrawCalculationsStatus["CURRENCY_NOT_CONFIGURED_FOR_PAYMENT_GATEWAY"] = "CURRENCY_NOT_CONFIGURED_FOR_PAYMENT_GATEWAY";
})(PmWithdrawCalculationsStatus || (exports.PmWithdrawCalculationsStatus = PmWithdrawCalculationsStatus = {}));
